import { jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import Balancer, { Provider } from 'react-wrap-balancer';

const TextBalancer = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(Balancer, { ...props, ref })
);
const SYMBOL_NATIVE_KEY = "__wrap_n";
function setGlobalVariableForDetectingBrowserSupportNativeTextBalancing() {
  self[SYMBOL_NATIVE_KEY] = self[SYMBOL_NATIVE_KEY] || (self.CSS && CSS.supports("text-wrap", "balance") ? 1 : 2);
}
function TextBalancerProvider({
  children
}) {
  useEffect(() => {
    setGlobalVariableForDetectingBrowserSupportNativeTextBalancing();
  }, []);
  return /* @__PURE__ */ jsx(Provider, { children });
}

export { TextBalancerProvider, TextBalancer as default };
//# sourceMappingURL=TextBalancer.mjs.map
